export function ColumnMapping(client) {
    return {
        dataFrameColumns: {
            get(params) {
                return client.get(`/accounts/${params.masterAccountId}/upload-sets/${params.uploadSetId}/upload-files/${params.uploadFileId}/data-frames/${params.dataFrameId}/columns`);
            },
            add(params, fieldId, defaultValue = null, saveAsRule = true) {
                let newColumn = {
                    createType: 'add',
                    fieldId,
                    saveAsRule: saveAsRule
                };
                if (defaultValue) {
                    newColumn = Object.assign({ defaultValue }, newColumn);
                }
                return client.post(`/accounts/${params.masterAccountId}/upload-sets/${params.uploadSetId}/upload-files/${params.uploadFileId}/data-frames/${params.dataFrameId}/columns`, newColumn);
            },
            put(params, columnUpdates) {
                return client.put(`/accounts/${params.masterAccountId}/upload-sets/${params.uploadSetId}/upload-files/${params.uploadFileId}/data-frames/${params.dataFrameId}/columns`, columnUpdates);
            },
            map(params, columnIdToFieldId) {
                const columnUpdates = Object.keys(columnIdToFieldId).map(key => ({
                    columnId: key,
                    fieldId: columnIdToFieldId[key],
                    updateType: 'mapToField',
                    saveAsRule: true
                }));
                return client.put(`/accounts/${params.masterAccountId}/upload-sets/${params.uploadSetId}/upload-files/${params.uploadFileId}/data-frames/${params.dataFrameId}/columns`, columnUpdates);
            },
            ignore(params, columnIdToIgnoredStatus) {
                const columnUpdates = Object.keys(columnIdToIgnoredStatus).map(key => ({
                    columnId: key,
                    ignoredStatus: columnIdToIgnoredStatus[key],
                    updateType: 'setIgnoredStatus',
                    saveAsRule: false
                }));
                return client.put(`/accounts/${params.masterAccountId}/upload-sets/${params.uploadSetId}/upload-files/${params.uploadFileId}/data-frames/${params.dataFrameId}/columns`, columnUpdates);
            }
        },
        fieldSuggestions: {
            get(params) {
                return client.get(`/accounts/${params.masterAccountId}/upload-sets/${params.uploadSetId}/upload-files/${params.uploadFileId}/data-frames/${params.dataFrameId}/columns/field-suggestions`);
            }
        },
        previouslyAppliedMappings: {
            get(params) {
                return client.get(`/accounts/${params.masterAccountId}/upload-sets/${params.uploadSetId}/upload-files/${params.uploadFileId}/data-frames/${params.dataFrameId}/columns/previously-applied-mappings`);
            }
        }
    };
}
